import { useEffect, useState } from 'react';
import { MessageOutlined, RightOutlined } from '@ant-design/icons';

import styles from './chatbotWidget.module.scss';

const CHATBOT_SCRIPT_SRC =
	'https://internal.supremecomponents.com/automate/sci-chatbot-internal/chatbot.js';
const CHATBOT_SCRIPT_ID = 'sci-chatbot-script';
const COLLAPSED_STORAGE_KEY = 'eden_chatbot_collapsed';

/**
 * @desc Loads the internal SCI chatbot once for logged-in users and adds a dockable
 * edge tab so it can be tucked to the right side and revealed again on hover/click
 */
const ChatbotWidget = () => {
	const [collapsed, setCollapsed] = useState(
		() => localStorage.getItem(COLLAPSED_STORAGE_KEY) === 'true',
	);

	useEffect(() => {
		if (document.getElementById(CHATBOT_SCRIPT_ID)) return;

		const script = document.createElement('script');
		script.id = CHATBOT_SCRIPT_ID;
		script.src = CHATBOT_SCRIPT_SRC;
		script.async = true;
		document.body.appendChild(script);
	}, []);

	useEffect(() => {
		document.body.classList.toggle('eden-chatbot-collapsed', collapsed);
		localStorage.setItem(COLLAPSED_STORAGE_KEY, collapsed);

		if (collapsed) window.SCIChatbot?.close();
	}, [collapsed]);

	return (
		<button
			type="button"
			className={`${styles['dockTab']} ${collapsed ? styles['collapsed'] : ''}`}
			onClick={() => setCollapsed(!collapsed)}
			aria-label={collapsed ? 'Show chatbot' : 'Hide chatbot'}
			title={collapsed ? 'Show chatbot' : 'Hide chatbot'}
		>
			{collapsed ? <MessageOutlined /> : <RightOutlined />}
		</button>
	);
};

export default ChatbotWidget;
